import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * Card that groups related settings, with hairline dividers between the rows it
 * contains. Pair with {@link SettingRow}.
 */
export function SettingsPanel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'divide-y divide-border rounded-xl border border-border bg-card',
        className,
      )}
    >
      {children}
    </div>
  );
}

/**
 * A single labelled setting: label and optional description on the left, the
 * control on the right. Stacks vertically below the `sm` breakpoint.
 */
export function SettingRow({
  label,
  description,
  htmlFor,
  children,
}: {
  label: string;
  description?: string;
  htmlFor?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3 px-6 py-5 sm:flex-row sm:items-start sm:gap-12">
      <div className="min-w-0 sm:w-1/3 sm:shrink-0">
        <label htmlFor={htmlFor} className="text-sm font-medium text-foreground">
          {label}
        </label>
        {description ? (
          <p className="mt-1 text-pretty text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      <div className="min-w-0 sm:flex-1">{children}</div>
    </div>
  );
}
